import objToParams from '../utils/obj-to-params';
import extractJson from '../utils/extract-json';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export async function azulGet(endpoint, params, useSessionToken = true, authToken) {
  // throw earlier if useSessionToken and no session token found
  // if (useSessionToken && !getSessionToken()) {
  //   throw new LuftHttpError(401, UNAUTHORIZED_ERROR_MESSAGE);
  // }

  const url = BASE_URL + endpoint + objToParams(params);

  const config = {
    method: 'GET',
    headers: new Headers({
      // ...(useSessionToken || authToken ? { Authorization: `Bearer ${useSessionToken ? getSessionToken() : authToken}` } : {}),
      'Content-Type': 'application/json',
    }),
  };

  const response = await fetch(url, config);
  const responseJson = await extractJson(response);

  return responseJson;
}

// POST

export async function azulPost(endpoint, requestBody, isFormData = false, useSessionToken = true, authToken) {
  // throw earlier if useSessionToken and no session token found
  // if (useSessionToken && !getSessionToken()) {
  //   throw new LuftHttpError(401, UNAUTHORIZED_ERROR_MESSAGE);
  // }

  const body = isFormData ? requestBody : (requestBody ? JSON.stringify(requestBody) : null);

  const config = {
    method: 'POST',
    body,
    headers: new Headers({
      // ...(useSessionToken || authToken ? { Authorization: `Bearer ${useSessionToken ? getSessionToken() : authToken}` } : {}),
      ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
    }),
  };

  const response = await fetch(BASE_URL + endpoint, config);
  const responseJson = await extractJson(response);

  return responseJson;
}
